module.exports = __webpack_public_path__ + "static/media/161008-DSC05310-44_Small.98151685.jpg";